import { inject, Injectable } from '@angular/core';
import { ApiQuery } from '@kinet-open-network/client/core/api-client';
import { TasksService } from '@kinet-open-network/client/tasks/data-access';
import { CustomersStore } from '../+state/customers.store';

/**
 * Scopes every request to the current customer by appending a `customerId`
 */
@Injectable()
export class CustomerTasksService extends TasksService {
  private readonly customersStore = inject(CustomersStore);

  protected override appendQuery = (query?: ApiQuery | null): ApiQuery => {
    const customerFilter = `customerId eq "${this.customersStore.modelId()}"`;

    return {
      ...query,
      filters: query?.filters
        ? `(${query.filters}) and (${customerFilter})`
        : customerFilter,
    };
  };
}
